import { ComponentType } from "react";

import { PAGES, type PageName } from "../../../stores/ViewStore";
import { FEATURE_FLAGS } from "../../../stores/featureFlags";


import { ArticleIcon } from "../../components/icons/ArticleIcon";
import { QuizIcon } from "../../components/icons/QuizIcon";
import { CheckListIcon } from "../../components/icons/editor/CheckListIcon";
import { UpgradeIcon } from "../../components/icons/UpgradeIcon";
import { SettingsIcon } from "../../components/icons/SettingsIcon";
import { ExternalLinkIcon } from "../../components/icons/ExternalLinkIcon";
import { MarkAsReadIcon } from "../../components/icons/MarkAsReadIcon";
import { AuditsIcon } from "../../components/icons/AuditsIcon";
import { FinanceIcon } from "../../components/icons/FinanceIcon";
import { ReviewsIcon } from "../../components/icons/ReviewsIcon";


export interface NavigationItem {
    id: string;
    label: string;
    icon: ComponentType<any>;
    page: PageName | 'help-external';
    subPages: PageName[];
    section: 'tools' | 'settings';
    /** When set, the item is only shown if this feature flag is enabled. */
    featureFlag?: string;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
    {
        id: 'knowledge-base', label: 'Knowledge Base', icon: ArticleIcon, page: PAGES.KNOWLEDGE_BASE, section: 'tools',
        subPages: [PAGES.KNOWLEDGE_BASE, PAGES.DOC_EDIT, PAGES.DOC_HISTORY],
    },
    {
        id: 'tests', label: 'Tests', icon: QuizIcon, page: PAGES.QUIZZES, section: 'tools',
        subPages: [
            PAGES.QUIZZES,
            PAGES.QUIZ_EDIT,
            PAGES.QUIZ_VIEW,
            PAGES.QUIZ_TAKE,
        ],
    },
    {
        id: 'acknowledgments',
        label: 'Acknowledgments Overview',
        icon: MarkAsReadIcon,
        page: PAGES.ACKNOWLEDGMENTS_OVERVIEW,
        section: 'tools',
        subPages: [PAGES.ACKNOWLEDGMENTS_OVERVIEW],
    },
    {
        id: 'tasks', label: 'Recurring Tasks', icon: CheckListIcon, page: PAGES.LISTS, section: 'tools',
        subPages: [
            PAGES.LISTS
        ],
    },
    {
        id: 'task-performance', label: 'Task Performance', icon: ReviewsIcon, page: PAGES.TASK_PERFORMANCE, section: 'tools',
        subPages: [PAGES.TASK_PERFORMANCE], featureFlag: FEATURE_FLAGS.TASK_PERFORMANCE,
    },
    {
        id: 'audits', label: 'Audits', icon: AuditsIcon, page: PAGES.AUDITS, section: 'tools',
        subPages: [PAGES.AUDITS], featureFlag: FEATURE_FLAGS.AUDIT,
    },
    {
        id: 'finance', label: 'Finance', icon: FinanceIcon, page: PAGES.FINANCE, section: 'tools',
        subPages: [PAGES.FINANCE], featureFlag: FEATURE_FLAGS.FINANCE,
    },
    {
        id: 'billing',
        label: 'Plans & Billing',
        icon: UpgradeIcon,
        page: PAGES.SETTINGS_BILLING,
        section: 'settings',
        subPages: [
            PAGES.SETTINGS_BILLING,
        ],
    },
    {
        id: 'settings', label: 'Settings', icon: SettingsIcon, page: PAGES.SETTINGS_GENERAL, section: 'settings',
        subPages: [
            PAGES.SETTINGS,
            PAGES.SETTINGS_MEMBERS,
            PAGES.SETTINGS_GENERAL,
            PAGES.SETTINGS_PROFILE,
            PAGES.WORKSPACE_SETTINGS_GENERAL,
            PAGES.WORKSPACE_MEMBERS,
        ],
    },
    {
        id: 'help', label: 'Help', icon: ExternalLinkIcon, page: 'help-external', section: 'settings',
        subPages: [],
    },
];

export const SIDEBAR_WIDTH_EXPANDED = 280;
export const SIDEBAR_WIDTH_COLLAPSED = 56;
